export default {
  promptFn: ({
    commit
  }, t) => {
    commit('promptFn', t)
  },
  devFn: ({
    commit
  }, t) => {
    commit('devFn', t)
  },
  videoObjFn: ({
    commit
  }, t) => {
    commit('videoObjFn', t)
  },
  audioObjFn: ({
    commit
  }, o) => {
    commit('audioObjFn', o)
  },
  loadingFn: ({
    commit
  }, t) => {
    commit('loadingFn', t)
  },
  loadFontFn: ({
    commit
  }) => {
    commit('loadFontFn')
  },
  videoComFn: ({
    commit
  }, t) => {
    commit('videoComFn', t)
  },

  resVideoFn: ({
    commit
  }, t) => {
    commit('resVideoFn', t)
  },
  lastComFn: ({
    commit
  }, t) => {
    commit('lastComFn', t)
  },
  recordingFn: ({
    commit
  }, r) => {
    commit('recordingFn', r)
  },
  sexFn: ({
    commit
  }, t) => {
    commit('sexFn', t)
  },
  scoreFn: ({
    commit
  }, arr) => {
    commit('scoreFn', arr)
  },
  resVideoObjFn: ({
    commit
  }, t) => {
    commit('resVideoObjFn', t)
  },
  isWeiXinFn: ({
    commit
  }, n) => {
    commit('isWeiXinFn', n)
  },
  lastShowFn: ({
    commit
  }, t) => {
    commit('lastShowFn', t)
  }
}